import type { ContractStatus } from "@asap/shared/utils/supabase.enum";
import type { ContractStatusTranslateRoles } from "@asap/shared/utils/translate";

type StatusBadgeRoleInput = {
  status: ContractStatus;
  canValidate: boolean;
  isAccounting: boolean;
  isConsultant: boolean;
};

/** The wording and color of a status badge depend on who looks at it. */
export const getStatusBadgeRole = ({
  status,
  canValidate,
  isAccounting,
  isConsultant,
}: StatusBadgeRoleInput): ContractStatusTranslateRoles => {
  if (isAccounting) return "accounting_team_member";
  if (status === "to_validate" && canValidate) return "manager_team_member";
  if (isConsultant) return "consultant_team_member";
  return "default";
};

type ValidatorBadgeInput = {
  status: ContractStatus;
  isIndependentAdministrator: boolean;
  teamMemberWorkspaceId: string | undefined;
  asapWorkspaceId: string | undefined;
};

/** Badge of the tables that still pass the current user as the contract owner. */
export const isBadgedAsValidatorOfOwnContract = ({
  status,
  isIndependentAdministrator,
  teamMemberWorkspaceId,
  asapWorkspaceId,
}: ValidatorBadgeInput): boolean =>
  status === "to_validate" &&
  isIndependentAdministrator &&
  teamMemberWorkspaceId !== undefined &&
  teamMemberWorkspaceId !== asapWorkspaceId;
